<div class="details-container">

  <div class="details-header" style="background: url(assets/images/cchs1.jpg);">
      
    <div class="details-banner">
        <h1>Chelmsford County High School for Girls</h1>
        <h2>11 Plus (11+) Exam Information</h2>
    </div>
</div>


<div class="details-publisher">
  <span><strong>Published by - SEHYOG Academy</strong></span>
</div>

<div class="details-content">

  <div class="details-section">

    <h2>Selective Chelmsford Grammar School</h2>

    <div class="spacer"></div>

    <p>Chelmsford County High School for Girls, situated in Chelmsford, Essex, was established in 1906. The school welcomes female students between the ages of 11 and 18 and is considered one of the most competitive grammar schools in Essex concerning admissions. It was converted to an academy in 2011. <br> <br>

 

      The school’s curriculum is challenging, and its goal is to evoke a passion for learning, encouraging pupils to actively participate in all lessons. Key subjects include science, maths, English and the arts. The curriculum is revised regularly to ensure that students receive the best possible education and are inspired to do their best individually and collectively as a community. <br> <br>
      
       
      
      CCHS school students achieve outstanding results in GCSE and A-Level exams. In 2024, a staggering 86% of GCSE grades were in the 9-7 range, and 85% of A-Level grades were in the A*-B range. Unsurprisingly, many Year 13 leavers go on to study at prestigious universities. <br> <br>
      
       
      
      Ofsted rated the school as “Outstanding” across all areas after completing an inspection in 2024. The 2024 Ofsted report highlights the superb behaviour of pupils, the expertise of teachers and the care taken to ensure the wellbeing of pupils.</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

   <h2>CCHS: Extensive Extracurricular Activities</h2>

   <p>Chelmsford County High School for Girls offers a wide range of extracurricular activities which help students further develop their interests and ambitions. Among the most popular are the electronics club, drama club, sports journalism, debate club and gospel choir. The school also arranges various charity activities throughout the year. <br> <br>

 

    The school’s vision is to inspire its pupils to think independently and act with compassion for others. It aims to build a community where everybody cares for each other and contributes to the best of their abilities. It also emphasises the importance of motivation for learning, enabling students to pursue their passions and consistently acquire new knowledge.</p>

    
    <div class="spacer"></div>

    <div class="spacer"></div>



    <h3>Four Aspects of CCHS Chelmsford Worth Highlighting</h3>

    
    <div class="spacer"></div>

    <p>Chelmsford County High School for Girls deserves to have the following points highlighted, as they sum up everything you would want in a school for your child: <br> <br>

 

      Caring community: The 2024 Ofsted report refers to the school’s “caring environment”. Girls treat each other respectfully and are inclusive, creating a caring community where your child would thrive. <br> <br>
      
       
      
      Curriculum excellence: The 2024 Ofsted report tells us, “Curriculum planning is meticulous”, meaning your child would be able to reach their full academic potential at CCHS. Pupils are stretched appropriately and do not have gaps in their knowledge that could negatively impact future learning. <br> <br>
      
       
      
      Holistic education: The 2024 Ofsted report says, “This school is not just about academia.” CCHS also sees your child’s emotional, social, physical, artistic and moral development as crucial. The school’s holistic education means your child would leave CCHS as a well-rounded, accomplished, compassionate individual. <br>
      
       
      
      Student wellbeing: The 2024 Ofsted report mentions that student wellbeing is “at the heart” of the work of the school’s trustees. CCHS prioritises the mental health of its students through dedicated support systems. Staff regularly check in with students to address their needs, meaning your child would feel valued and happy at CCHS.</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h3>Music at Chelmsford County High School for Girls</h3>

    <div class="spacer"></div>

    <p>Music plays an important role at CCHS, with it being a specialism of the school. It is a compulsory subject in Years 7-9, and many girls choose to continue studying it for GCSE, with some then going on to do A-Level Music. <br> 

 

      CCHS’s Music Centre, completed in 2007, houses two large classrooms, practice rooms and a fully equipped recording studio. These excellent resources help girls develop their musical talents. <br> <br>
      
       
      
      As a key feature of the extracurricular programme, there are many musical activities girls can get involved in, such as samba band, brass ensemble, jazz band, guitar ensemble and wind band. Girls can also have individual instrumental lessons, choosing from a wide variety of instruments, including saxophone, French horn, cello, violin, flute and keyboard. <br> <br>
      
       
      
      Additionally, the school holds formal concerts each year and has even arranged music tours in Europe. <br> <br>
      
       
      
      If your daughter loves music, she will be thrilled by the numerous opportunities to pursue her passion at CCHS.</p>


      <div class="spacer"></div>
    <div class="spacer"></div>


      <h3>Sport at Chelmsford County High School for Girls</h3>
      <div class="spacer"></div>

      <p>Sport is also a key component of life at CCHS, with PE being compulsory for all year groups. PE GCSE has proved so popular that CCHS started offering PE A-Level in 2023. The school’s sporting facilities are superb. They include a swimming pool, netball courts/tennis courts and a new Sports Centre that opened in 2022. The Sports Centre has a sports hall, dance studio, gym and fitness suite. <br> <br>

 

        As with music, sport is a key feature of the extracurricular programme. Sporting activities are offered before school, during lunchtime, after school and at the weekends. The sports on offer include cricket, fencing, netball, athletics, badminton and rounders. Teams compete against other teams at local, district, regional and national levels. <br> <br>
        
         
        
        If your daughter is enthusiastic about sport, she will be more than satisfied with the sporting choices at CCHS.</p>


        <div class="spacer"></div>
    <div class="spacer"></div>

    <h3>Interesting Facts About Chelmsford County High School for Girls’ History</h3>


    <div><img src="assets/images/check-list.png" alt=""> <p>Despite being founded in 1906, CCHS did not officially open until 1907.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>In 1907, the school only had 76 girls enrolled, but this number has steadily increased over the years.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>The school used to charge fees. In 1908, fees were nine guineas.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>In 1910, the school offered boarding places to pupils who lived a long distance from the school. However, boarding ceased in 1936 as not enough pupils chose to board, making it financially unviable.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Girls used to wear straw boaters, black stockings, gym slips and white blouses.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Both World War One and World War Two impacted the school, with air raids disrupting lessons and buildings being damaged in WWII.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>In 1987, two pupils appeared on a television quiz show and won holidays!</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>Mr Lawlor became the headteacher in 2019 — the school’s first male headteacher.</p></div>

    <div class="spacer"></div>

    <div class="spacer"></div>

    <h2>Chelmsford County High School for Girls’ Notable Achievements</h2>

    <div class="spacer"></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>In 2022, not for the first time, Arts Council England awarded CCHS the Artsmark Gold Award. The award recognises the school’s fantastic arts and culture provision.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>In 2022, CCHS was proud to become a member of the International Coalition of Girls’ Schools (ICGS) as one of the founding schools, demonstrating the school’s dedication to providing girls with a first-rate education.</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p>In 2024, CCHS was pleased to receive the NACE Challenge Award, which recognises the school’s commitment to challenging gifted pupils.</p></div>


    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Alumni of Chelmsford County High School for Girls</h2>

    <div class="spacer"></div>

    <p>Many former pupils of Chelmsford County High School for Girls have led, or are leading, hugely fulfilling and successful lives, in no small part due to the outstanding education they received at the school. The following women were educated at CCHS:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p>Dame Margaret Joan Anstee: Anstee went to Cambridge University after finishing her education at CCHS and became a British diplomat, serving at the United Nations. She became Under-Secretary-General of the UN in 1987, a significant achievement because she was the first woman to hold this high-ranking position.</p></div>


    <div><img src="assets/images/check-list.png" alt=""> <p>Catharni Stern: Stern was a successful sculptor who was educated at CCHS. She had a number of exhibitions, including one at the Ransome Gallery in the 1970s. Her sculptures can be seen in various locations, such as her bronze Francis of Assisi in Chelmsford and her terracotta one in Langford.</p></div>


    <div><img src="assets/images/check-list.png" alt=""> <p>Dame Karen Patricia Buck: Buck attended the prestigious London School of Economics after leaving CCHS. Since then, she has served as a Member of Westminster City Council and as a Member of Parliament. She is a compassionate woman who spoke up in 2018 against the treatment of homeless Londoners.</p></div>


    <div class="spacer"></div>
    <div class="spacer"></div>

   
    <h2>Chelmsford County High School 11 Plus (11+) Exam Information</h2>

    <div class="spacer"></div>

    <p><strong>Address </strong> Broomfield Road, Chelmsford, CM1 1RW</p>
    <p><strong>County:</strong> Essex, 11 Plus Essex</p>
    <p><strong>Admissions info:</strong> admissions&#64;cchs.co.uk, 01245 352592</p>
    <p><strong>School type:</strong> Girls’ Grammar</p>
    <p><strong>Number of pupils: </strong> 1186+</p>
    <p><strong>Number of places in Year 7: </strong> 180</p>
    <p><strong>CCHS Open Day date: </strong> April of Year 5</p>
    <p><strong>11+ Exam date: </strong> September of Year 6</p>
    <p><strong>Chelmsford County High School Pass Mark: </strong> Aim for 80%+ in our practice tests. See below for more details.</p>
    <p><strong>Exam type / Board: </strong> FSCE (Future Stories Community Enterprise)</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Chelmsford County High School for Girls 11 Plus (11+) Admissions</h2>

    <p>Admission to Chelmsford County High School for Girls is based on a pupil’s performance in the 11 Plus entrance exam. All applicants must satisfy the school’s criteria, and it should be noted that passing the CCHS entrance test isn’t a guarantee of a place in Year 7.</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Chelmsford 11 Plus Registration</h2>

    <p>You must register directly with CCHS for your child to be able to sit the Year 7 entrance test.

 

      More information on the CCHS admissions process can be found on the school website.</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>How To Apply for 11 Plus (11+) Entry to Chelmsford County High School for Girls</h2>

    <h3>The CCHS Admissions Process for Year 7 Entry With Key Dates</h3>

    <p>1. Between April and June, when your child is in Year 5, you must complete the school’s online Supplementary Information Form for your child to be eligible to sit the Year 7 CCHS entrance exam. <br>
      2. In late April of Year 5, CCHS will hold an Open Day, giving you and your child the opportunity to listen to a presentation by the Head, tour the school campus and ask any questions you have. <br>
      3. Late August, you will be sent details about the CCHS Year 7 entrance assessment.
      4. In September of Year 6, your child will sit the CCHS Year 7 entrance test.
      5. In October of Year 6, you will receive your child’s Chelmsford County High School 11 plus results, informing you whether she has achieved an eligible score for entry to CCHS. Please remember, an eligible score does not guarantee she will be offered a place, as there are likely to be more candidates with an eligible score than there are available places. <br>
      6. By the end of October of Year 6, you must have submitted your completed Common Application Form (CAF) to your child’s local authority. <br>
      7. In March of Year 6, you will find out whether your child has been successful in securing a place at CCHS.</p>

      <div class="spacer"></div>

    <p>Additional documents needed to complete the Supplementary Information Form (SIF) include: <br>

      1. A passport-sized photograph of the applicant <br> 
      2. Proof of address, including a council tax bill and two utility bills <br>
      3. A copy of your tenancy agreement, if living in rented property <br>
      4. Evidence to support any request for special requirements <br>
      5. Evidence to support Pupil Premium eligibility or Looked After Child status.
      
       </p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>Does Chelmsford County High School for Girls Have a Catchment Area?</h2>

    <div class="spacer"></div>

    <p>The Chelmsford County High School 11+ entrance examination is created by an exam board called FSCE. The test consists of the following assessments:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p><strong>Paper 1:</strong> mathematics and English skills (multiple-choice format; 45 minutes in length)</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p><strong>Paper 2:</strong> mathematics and English (constrained/free response format; 35 minutes in length)</p></div>

    <div><img src="assets/images/check-list.png" alt=""> <p><strong>Paper 2:</strong> mathematics and English (constrained/free response format; 35 minutes in length)</p></div>

    <p>Test results are fully standardised and age-weighted to ensure fairness for all those sitting the exams. Results are communicated in mid-October and formal offers are distributed in early March.</p>


    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>How To Prepare for the Chelmsford County High School for Girls 11 Plus (11+) Exam</h2>

    <p>Preparation for the 11 Plus entrance exam should begin early. The sooner your daughter begins her preparation, the more time she’ll have to improve any weak areas. <br> <br>

 

      We advise students to create a revision timetable that covers all the elements they’ll need to know for the exam. Additionally, introducing practice exam papers early can provide a good indication of their current abilities. <br> <br>
      
       
      
      As the exam approaches, it’s a good idea to have your daughter do timed practice papers so she gets used to answering questions quickly and under pressure. The more practice papers she completes under test conditions, the better her time management skills will become. <br>
      
       
      
      Not only do practice exam papers help with time management, but they’re also a great way to help familiarise your child with the types of questions she may be asked on the day of the test. They also help students become familiar with the layout of the exam.</p>

      <div class="spacer"></div>

      <h2>Chelmsford County High School 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

      <div class="spacer"></div>

      <p>Pupils who are able to score 80%+ consistently in our 11+ practice tests for Chelmsford County School should be on track to pass the 11+ assessment. <br> <br>

 

        Whilst there are no guarantees, this has historically been a fairly strong indicator that your child should do well in the CCHS 11+ exam.</p>


</div>

</div>